import { render } from "./GastoDeCapitalComponent.vue?vue&type=template&id=5a7ca794&scoped=true"
import script from "./GastoDeCapitalComponent.vue?vue&type=script&lang=js"
export * from "./GastoDeCapitalComponent.vue?vue&type=script&lang=js"

import "./GastoDeCapitalComponent.vue?vue&type=style&index=0&id=5a7ca794&scoped=true&lang=css"

import exportComponent from "/Users/luismanuel/Documents/www/tuxtlacomovamos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a7ca794"]])

export default __exports__